import type { SignupAttribution } from './signupApi';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export function captureAttribution(): SignupAttribution {
  const params = new URLSearchParams(window.location.search);
  const attribution: SignupAttribution = {};

  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) attribution[key] = value;
  }
  // Same-origin referrers say nothing about acquisition.
  if (document.referrer && new URL(document.referrer).origin !== window.location.origin) {
    attribution.referrer = document.referrer;
  }
  attribution.landing_path = window.location.pathname;

  return attribution;
}
